// extracted by mini-css-extract-plugin
export default {"icon":"wwkx9b"};